import React from 'react'
import './about.css'
import ME from '../../assets/me-about.jpeg'
import {FaAward, FaProjectDiagram} from 'react-icons/fa'
import {FiUsers} from 'react-icons/fi'

const About = () => {
    return (
        <section id='about'>
            <h5>Get To Know</h5>
            <h2>About Me</h2>
            <div className="container about__container">
                <div className="about__me">
                    <div className="about__me-image">
                        <img src={ME} alt="About imagephoto"/>
                    </div>
                </div>

                <div className="about__content">
                    <div className="about__cards">
                        <article className='about__card'>
                            <FaAward className='about__icon'/>
                            <h5>Full-Stack Development</h5>
                            <small>Building scalable front-end & back-end solutions</small>
                        </article>

                        <article className='about__card'>
                            <FiUsers className='about__icon'/>
                            <h5>Cloud & DevOps</h5>
                            <small>Experience with Docker, Kubernetes, CI/CD, AWS</small>
                        </article>

                        <article className='about__card'>
                            <FaProjectDiagram className='about__icon'/>
                            <h5>Problem Solving</h5>
                            <small>Turning business needs into real-world solutions</small>
                        </article>
                    </div>


                    <p>
                        I’m a passionate Full-Stack Developer with hands-on expertise in designing and building
                        scalable, high-performance web applications. My work spans across backend engineering, front-end
                        development, and database-driven solutions, with a growing interest in data engineering and
                        advanced analytics. Currently, I’m diving deeper into cloud-native architectures, distributed
                        systems, and microservices, exploring how modern platforms like Docker, Kubernetes, and AWS can
                        be leveraged to deliver resilient, future-ready software solutions. I thrive at the intersection
                        of clean code, problem-solving, and continuous learning, always aiming to craft systems that are
                        not only functional but also robust, secure, and user-friendly.
                    </p>

                    <a href="#contact" className='btn btn-primary'>Let's Talk</a>
                </div>

            </div>
        </section>
    )
}

export default About
